import React, { useState } from 'react';
import { authAPI } from '../api';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card } from '@/components/ui/card';
import { toast } from 'sonner';
import { Smartphone, Loader2 } from 'lucide-react';

export const LoginPage = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [otp, setOtp] = useState('');
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleSendOTP = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authAPI.sendOTP(phoneNumber);
      toast.success('OTP sent successfully');
      setStep(2);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to send OTP');
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await authAPI.verifyOTP(phoneNumber, otp);
      login(response.data.token, response.data.user);
      toast.success('Login successful!');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Invalid OTP');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 md:p-6" style={{ background: 'linear-gradient(135deg, #FBF9F6 0%, #F5F1E8 100%)' }}>
      <div className="w-full max-w-md">
        <div className="text-center mb-6 md:mb-8">
          <img src="/logo.jpg" alt="Vikas Industries" className="w-full max-w-xs sm:max-w-md mx-auto mb-4 object-contain" />
          <h1 className="text-3xl sm:text-4xl font-bold mb-2" style={{ color: '#2B5339' }}>Vikas Industries</h1>
          <p className="text-base" style={{ color: '#5C6B61' }}>E 302-303, RIICO, Palsana-332402 (Rajasthan)</p>
        </div>

        <Card className="p-6 md:p-8 bg-white border" style={{ borderColor: '#E2DFD8' }}>
          {step === 1 ? (
            <form onSubmit={handleSendOTP} data-testid="send-otp-form">
              <div className="mb-6">
                <label className="block text-sm font-medium mb-2" style={{ color: '#1E2420' }}>
                  Mobile Number
                </label>
                <Input
                  data-testid="phone-input"
                  type="tel"
                  placeholder="+91XXXXXXXXXX"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  required
                  className="w-full"
                />
                <p className="text-xs mt-2" style={{ color: '#5C6B61' }}>
                  Enter your mobile number to receive OTP
                </p>
              </div>
              <Button
                data-testid="send-otp-btn"
                type="submit"
                disabled={loading}
                className="w-full"
                style={{ background: '#2B5339' }}
              >
                {loading ? (
                  <>
                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                    Sending...
                  </>
                ) : (
                  'Send OTP'
                )}
              </Button>
            </form>
          ) : (
            <form onSubmit={handleVerifyOTP} data-testid="verify-otp-form">
              <div className="mb-6">
                <label className="block text-sm font-medium mb-2" style={{ color: '#1E2420' }}>
                  Enter OTP
                </label>
                <Input
                  data-testid="otp-input"
                  type="text"
                  placeholder="123456"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  required
                  maxLength={6}
                  className="w-full text-center text-2xl tracking-widest"
                />
                <p className="text-xs mt-2" style={{ color: '#5C6B61' }}>
                  OTP sent to {phoneNumber}
                </p>
              </div>
              <Button
                data-testid="verify-otp-btn"
                type="submit"
                disabled={loading}
                className="w-full mb-3"
                style={{ background: '#2B5339' }}
              >
                {loading ? (
                  <>
                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                    Verifying...
                  </>
                ) : (
                  'Verify OTP'
                )}
              </Button>
              <Button
                data-testid="back-btn"
                type="button"
                variant="outline"
                onClick={() => setStep(1)}
                className="w-full"
              >
                Back
              </Button>
            </form>
          )}
        </Card>

        <div className="mt-6 text-center">
          <p className="text-sm" style={{ color: '#5C6B61' }}>
            Only registered dealers can login. Contact admin if your number is not registered.
          </p>
        </div>
      </div>
    </div>
  );
};